<template>
  <div class="customer-biodata">
    <b-card no-body v-loading="_gHlp.isEmpty(activeCustomer)">
      <b-card-header class="border-0 p-3">
        <b-row align-v="center">
          <b-col cols="10">
            <h3 class="mb-0">
              {{ _gHlp.getValue(activeCustomer,'name','-') }}
            </h3>
          </b-col>
          <b-col cols="2">
            <el-button v-if="!_gHlp.isEmpty(activeCustomer)" @click="$refs.drawer_edit_profile.viewEditProfile()" class="float-right py-0 text-primary"
              type="text">Edit</el-button>
          </b-col>
        </b-row>
      </b-card-header>

      <b-container>
        <b-row class="px-3 mb-2" align-v="center">
          <b-col cols="auto" class="d-flex align-items-center border rounded px-2 py-1">
            <b-iconstack font-scale="2.5" class="mr-3">
              <b-icon stacked icon="square-fill" style="color: #D1DD52;"></b-icon>
              <!-- Dollar Icon -->
              <b-icon stacked icon="currency-dollar" scale="0.7" class="text-white"></b-icon>
            </b-iconstack>
            <div>
              <p class="text-xs">DSR</p>
              <p class="text-success">{{ _gHlp.getValue(activeCustomer,'incomes.main.dsr','N/A') }}</p>
            </div>
          </b-col>
          <b-col cols="auto" md="3">
            <div class="d-flex justify-content-start"  v-if="!_gHlp.isEmpty(activeCustomer)">
							<MessagingBoxButton :type="'invinity_customer'" :profile="activeCustomer" :msg_style="''" :btn_class="'p-2'" :badge_class="'mr-3'"/>
							<SmsBoxButton :profile="activeCustomer" :sms_style="''" :btn_class="'p-2'" :ctn_class="'mr-3'"/>
							<el-button type="primary" class="p-1" @click="sendWhatsapp(activeCustomer)">
								<svg xmlns="http://www.w3.org/2000/svg" class="rounded-circle p-1 bg-primary" width="28" height="28"
                  viewBox="0 0 24 24">
                  <path fill="#fff"
                    d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                </svg>
							</el-button>
						</div>
            <!-- <div class="d-flex justify-content-start"  v-if="!_gHlp.isEmpty(activeCustomer)">
              
              <el-button type="primary" class="p-2" @click="$refs.sms_drawer.viewSmsDrawer(activeCustomer)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
                  <path fill="currentColor"
                    d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-53.1-271.2c6.5-2.2 13.7.1 17.9 5.6l35.2 46.9 35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6S320 185.1 320 192v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-6.9 4.4-13 10.9-15.2zm173.1 38v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.2-.4-23.7-4.4-32.6-7.4-1.4-.5-2.7-.9-4-1.4-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7.6 3.3 1.1 4.9 1.6 9.1 3.1 15.6 5.3 22.6 5.5 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.4-17.7-14.7-17.7-29.4-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 10 .2 19.7 2.3 27.9 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9zm-272 0v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.3-.4-24.2-4.5-33.2-7.6-1.3-.4-2.5-.8-3.6-1.2-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4.5 2.8.9 4.1 1.4 9.5 3.2 16.5 5.6 23.7 5.8 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.3-17.7-14.6-17.8-29.3-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 9.5.1 22.2 2.1 31.1 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9z" />
                </svg>
              </el-button>
              <el-button type="primary" class="p-1"
                @click="sendWhatsapp(activeCustomer)">
                <svg xmlns="http://www.w3.org/2000/svg" class="rounded-circle p-1 bg-primary" width="28" height="28"
                  viewBox="0 0 24 24">
                  <path fill="#fff"
                    d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                </svg>
              </el-button>
            </div> -->
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col cols="auto">
            <p class="text-muted text-xs mb-1">
              <span>Latest Report: No Purchase</span>
            </p>
          </b-col>
        </b-row> -->
        <b-row class="my-3">
          <b-col cols="12">
            <div class="d-flex align-items-center mb-2" v-if="!_gHlp.isEmpty(_gHlp.getValue(activeCase,'case_id',null))">
              <small class="pr-3 font-weight-bolder text-gray">CASE ID</small>
              <p>{{ _gHlp.getValue(activeCase,'case_id','N/A') }}</p>
            </div>
            <div class="d-flex align-items-center mb-2">
              <small class="pr-3 font-weight-bolder text-gray">LMS ID</small>
              <p>{{ _gHlp.getValue(activeCustomer,'id','N/A') }}</p>
            </div>
            <div class="d-flex align-items-center mb-2">
              <small class="pr-3 font-weight-bolder text-gray">SAS ID</small>
              <p>{{ _gHlp.getValue(activeCustomer,'sas_im2u_id','N/A') }}</p>
            </div>
            <div class="d-flex align-items-center mb-2">
              <small class="pr-3 font-weight-bolder text-gray">PSAL ID</small>
              <p>{{ _gHlp.getValue(activeLoanEC,'psal_id','N/A') }}</p>
            </div>
            <div class="d-flex align-items-center mb-2">
              <small class="pr-3 font-weight-bolder text-gray">Company Registration No.</small>
              <p>{{ _gHlp.getValue(activeCustomer,'company_registration_no','N/A') }}</p>
            </div>
            <div class="d-flex align-items-center mb-2">
              <b-icon icon="person-fill" class="mr-3" variant="gray"></b-icon>
              <p>{{ !_gHlp.isEmpty(_gHlp.getValue(activeCustomer,'age',null)) ? activeCustomer.age + ' Years Old' : 'N/A' }}</p>
            </div>
						<div class="d-flex align-items-center mb-2">
								<b-icon icon="calendar-date-fill" class="mr-3" variant="gray"></b-icon>
								<p>{{ _gHlp.getValue(activeCustomer,'dob','N/A') }}</p>
						</div>
            <div class="d-flex align-items-center mb-2" v-if="!_gHlp.isEmpty(_gHlp.getValue(activeCustomer,'passport',null)) && _gHlp.getValue(activeCustomer,'is_foreigner',0) === 1">
              <b-icon icon="person-badge-fill" class="mr-3" variant="gray"></b-icon>
							<p>{{ _gHlp.getValue(activeCustomer,'passport','')}}</p>
            </div>
            <div class="d-flex align-items-center mb-2" v-if="!_gHlp.isEmpty(_gHlp.getValue(activeCustomer,'nric',null)) && _gHlp.getValue(activeCustomer,'is_foreigner',0) === 0">
              <b-icon icon="person-badge-fill" class="mr-3" variant="gray"></b-icon>
							<p>{{ _gHlp.getValue(activeCustomer,'nric','') | formatNRIC }}</p>
            </div>
						<div class="d-flex align-items-center mb-2">
              <b-icon icon="telephone-fill" class="mr-3" variant="gray"></b-icon>
              <p>{{ _gHlp.getValue(activeCustomer,'contact_no','N/A') }}</p>
            </div>
						<div class="d-flex align-items-center mb-2">
								<b-icon icon="building" class="mr-3" variant="gray"></b-icon>
								<p>{{ _gHlp.getValue(activeCustomer,'companies.current.name','N/A') }}</p>
						</div>
						<div class="d-flex align-items-center mb-2">
								<b-icon icon="briefcase-fill" class="mr-3" variant="gray"></b-icon>
								<p>{{ _gHlp.getValue(activeCustomer,'companies.current.position','N/A') }}</p>
						</div>
						<div class="d-flex align-items-center mb-2">
								<b-icon icon="grid" class="mr-3" variant="gray"></b-icon>
								<p>Channel : {{ _gHlp.getValue(activeCustomer,'channel.name','N/A') }}</p>
						</div>
          </b-col>
        </b-row>
      </b-container>
    </b-card>

    <DrawerEditProfile ref="drawer_edit_profile" />

  </div>
</template>
<script>
import { Tag, Card, Button, Select, Option, Row } from 'element-ui'
import DrawerEditProfile from '@/views/CustomerProfile/Drawers/DrawerEditProfile/DrawerEditProfile'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import SmsBoxButton from '@/views/Sms/SmsBoxButton'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useMessagingStore } from '@/stores/messagingStore';

export default {
  name: 'customer-biodata',
  components: {
    MessagingBoxButton,
    SmsBoxButton,
    DrawerEditProfile,
    [Row.name]: Row,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      // BASKET_COLOR:BASKET_COLOR,
      main_status: "",
      main_statuses: [],
      sub_statuses: [],
      current_status: "",
      status_value: "",
    }
  },
  computed: {
    ...mapState(useCustomerStore, ['activeCustomer','activeLoanEC']),
    ...mapState(useLoanCaseStore, ['activeCase']),
		is_loading(){
			return _gHlp.isLoading('fetch_customer') || _gHlp.isEmpty(activeCustomer)
		}
  },
	watch: {
  },
  created() {
  },
	mounted(){
		this.getMessageSummary()
	},
  methods: {
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
    sendWhatsapp(item) {
      let phoneNo = item.phone_no || item.contact_no;
      const prefix = phoneNo.substring(0,1);
      const countryPrefix = phoneNo.substring(1,2);
      if (prefix === '0') {
        if (countryPrefix === '8') {
          phoneNo = '62' + phoneNo.substring(1);
        } else {
          phoneNo = '6' + phoneNo;
        }
      }
      window.open(`https://api.whatsapp.com/send?phone=${phoneNo}`, '_blank');
    },
		getMessageSummary(){
			this.getProfileListMessagesSummaries('invinity_customer',[this.activeCustomer])
		}
  }
}
</script>